<div class="wrapper" (mouseleave)="leave.emit()">
	<!--  <div class="overlay"></div>-->
	<div class="header">
		<div class="header-content">
			<div class="title">Encounter Prevention</div>
			<div class="subtitle">This student can’t have passes at the same time as:</div>
		</div>
	</div>

	<div class="content">
		<div
			class="group-wrapper"
			[@NextStep]="{ value: '', params: frameMotion$ | async }"
			appCrossPointerEventTarget
			(pointerClickEvent)="goToEncounterPreventionGroup(groups[page])">
			<div class="group">
				<div class="group-name" *ngIf="groups[page].name">{{ groups[page].name }}</div>
				<div class="prevention-students">
					<div class="student" *ngFor="let student of groups[page].users">
						<div class="student-picture">
							<div
								*ngIf="student.profile_picture; else d"
								[ngStyle]="{ background: 'url(' + student.profile_picture + ') no-repeat left center/cover', width: '23px', height: '23px' }"></div>
							<ng-template #d>
								<img width="23" height="23" [src]="'./assets/Avatar Default.svg' | resolveAsset" alt="" />
							</ng-template>
						</div>
						<div class="name">{{ student.display_name }}</div>
					</div>
				</div>
				<div class="group-notes" *ngIf="groups[page].notes">{{ groups[page].notes }}</div>
			</div>
		</div>
		<div class="paginator" *ngIf="groups.length > 1">
			<div class="button" style="left: 0" *ngIf="page > 0" appCrossPointerEventTarget (pointerClickEvent)="prevPage()">
				<img width="25" height="23" [src]="'./assets/Chevron Left (White).svg' | resolveAsset" />
			</div>
			<div class="dots">
				<div
					class="dot"
					*ngFor="let g of groups; let i = index"
					[style.background-color]="page === i ? '#FFFFFF' : 'rgba(255,255,255, 0.5)'"
					appCrossPointerEventTarget
					(pointerClickEvent)="page = i"></div>
			</div>
			<div class="button" style="right: 0" *ngIf="page < groups.length - 1" appCrossPointerEventTarget (pointerClickEvent)="nextPage()">
				<img width="25" height="23" [src]="'./assets/Chevron Right (White).svg' | resolveAsset" />
			</div>
		</div>
	</div>
</div>
